<template>
  <div class="con-wrap full-page">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model="queryForm.name"
            @keyup.enter.native="query"
            placeholder="应用名称"
          ></el-input>
        </el-form-item>
        <el-button
          v-if="hasPerm('news:push:app:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('news:push:app:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          v-if="hasPerm('news:push:app:save')"
          type="primary"
          @click="addApplication"
          >新增</el-button
        >
        <el-button
          v-if="hasPerm('news:push:app:update')"
          type="primary"
          @click="modifyApplication"
          >修改</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('news:push:app:delete')"
          type="danger"
          @click.native="delApplication"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="appId" label="应用ID"></el-table-column>
      <el-table-column prop="name" label="应用名称"></el-table-column>
      <el-table-column prop="sysType" label="系统类型">
        <template slot-scope="scope">
          <span v-if="scope.row.sysType == 1">android</span>
          <span v-else-if="scope.row.sysType == 2">ios</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="xgId"
        label="信鸽ID"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="xgKey" label="信鸽KEY" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="vehicleModel" label="车型"></el-table-column>
      <el-table-column
        prop="addTime"
        label="创建时间"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <el-dialog
      :title="appTitle"
      :visible.sync="addApplicationVisible"
      class="application-dialog"
    >
      <el-form
        :rules="applicationRules"
        ref="applicationForm"
        :model="applicationForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="vehicleModelId" label="车型">
          <el-select
            v-model="applicationForm.vehicleModelId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in modelList"
              :key="item.id"
              :label="item.vehicleModel"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="appId" label="APP ID">
          <el-input
            v-model="applicationForm.appId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="name" label="名称">
          <el-input
            v-model="applicationForm.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="sysType" label="系统类型">
          <el-select v-model="applicationForm.sysType" placeholder="请选择">
            <el-option
              v-for="item in sysTypes"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="xgId" label="信鸽ID">
          <el-input
            v-model="applicationForm.xgId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="xgKey" label="信鸽KEY">
          <el-input
            v-model="applicationForm.xgKey"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addApplicationVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        name: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      tableVal: [],
      editTag: "0",
      addApplicationVisible: false,
      applicationForm: {},
      modelList: [],
      appTitle: "新增应用",
      sysTypes: [
        {
          id: 1,
          label: "android",
        },
        {
          id: 2,
          label: "ios",
        },
      ],
      applicationRules: {
        vehicleModelId: [
          {
            required: true,
            trigger: "change",
            message: "请选择车型",
          },
        ],
        appId: [
          {
            required: true,
            trigger: "change",
            message: "请输入appId",
          },
          {
            required: true,
            pattern: this.$formRules.noChinese,
            message: "请输入正确的appId",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入应用名称",
          },
        ],
        sysType: [
          {
            required: true,
            trigger: "change",
            message: "请选择系统类型",
          },
        ],
        xgId: [
          {
            required: true,
            trigger: "change",
            message: "请输入信鸽ID",
          },
          {
            required: true,
            pattern: this.$formRules.noChinese,
            message: "请输入正确的信鸽ID",
            trigger: "change",
          },
        ],
        xgKey: [
          {
            required: true,
            trigger: "change",
            message: "请输入信鸽KEY",
          },
          {
            required: true,
            pattern: this.$formRules.noChinese,
            message: "请输入正确的信鸽KEY",
            trigger: "change",
          },
        ],
      },
    }
  },
  created() {
    this.getApplicationList()
    this.getModelList()
  },
  methods: {
    async getApplicationList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        name: this.queryForm.name,
      }
      let _this = this
      let { data: res } = await _this.$axios.get("/api/news/push/app/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getApplicationList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getApplicationList()
    },
    async getModelList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/vehicle/model/options")
      if (res.code == 1) {
        _this.modelList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    addApplication() {
      this.editTag = "0"
      this.$resetForm(this, "applicationForm")
      this.applicationForm = {}
      this.appTitle = "新增应用"
      this.addApplicationVisible = true
    },
    saveOrUpdate() {
      let _this = this
      let data = []
      _this.$refs.applicationForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post(
              "/api/news/push/app",
              _this.applicationForm
            )
          } else {
            data = await _this.$axios.patch(
              "/api/news/push/app",
              _this.applicationForm
            )
          }
          let res = data.data
          if (res.code == 1) {
            _this.addApplicationVisible = false
            _this.$resetForm(_this, "applicationForm")
            _this.getApplicationList()
            _this.$message.success("操作成功")
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    async delApplication() {
      let _this = this
      //多选删除
      let ids = _this.$getIds(_this.tableVal)
      if (!ids) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/news/push/app", {
            data: JSON.stringify(ids),
          })
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getApplicationList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getApplicationList()
    },
    //修改详情
    async getApplicationInfo(id) {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/news/push/app/info/" + id
      )
      if (res.code == 1) {
        this.applicationForm = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //修改
    async modifyApplication() {
      this.applicationForm = {}
      if (this.tableVal.length > 1) {
        this.$message.warning("一次只能修改一条数据")
        return
      }
      let id = this.$getIds(this.tableVal)
      if (!id) {
        return
      }
      this.getApplicationInfo(id)
      this.addApplicationVisible = true
      this.appTitle = "修改应用"
      this.editTag = "1"
    },
  },
}
</script>

<style lang="scss" scoped>
.full-page {
  padding: 0 20px;
  background: #fff;
}
.application-dialog /deep/ .el-dialog {
  width: 600px;
}
.application-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.application-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
.application-dialog /deep/ .el-form-item__content {
  width: 360px;
}
.application-dialog /deep/ .el-date-editor.el-input {
  width: 360px;
}
</style>
